import Template from 'backbone/story/templates/comments/edit_form.js.hamlc'
import CommentUtils from 'utils/story/comment_utils.js'

export default class CommentEditFormView extends Backbone.View
  initialize: (options) ->
    @parentView = options.parentView
    @comment    = options.parentView.comment

  events:
    "click .button.js-comment-edit-cancel" : "onEditCancelClick"
    "click .button.js-comment-edit-save"   : "onEditSaveClick"
    "click .js-comment-edit-textarea"      : "stopPropagation"

  render: ->
    @$el.html(Template(body_text: @comment.attributes.body))
    contently.ui.autosizeTextarea(@$el)
    CommentUtils.initCommentMentioning(@$("#edit-comment-body"))
    @focusOnEnd()
    return this

  focusOnEnd: ->
    v = @$el.find("textarea").val()
    @$el.find("textarea").focus().val("").val(v)

  onEditCancelClick: ->
    @parentView.render()

  onEditSaveClick: (e) ->
    e.stopPropagation()
    body = @$(".js-comment-edit-textarea").val()
    @comment.save(
      { body: body, token: window.story.remote_token },
      wait: true,
      error: @onEditError,
      success: @onEditSuccess
    )

  onEditError: ->
    contently.flash.alert(
      "There was an error editing your comment, please try again."
    )

  onEditSuccess: =>
    @comment.set(thread_updated_at: moment().format())

  stopPropagation: (e) ->
    e.stopPropagation()



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/comment_edit_form_view.js.coffee